// Function to check if the viewport is in mobile size
function isMobileViewport() {
  return window.innerWidth < 768; // Adjust the breakpoint as needed
}

if (window.location.pathname === "/") {
  // Apply the CSS styles to the <html> element
  const htmlElement = document.querySelector("html");
  htmlElement.style.fontSize = "62.5%";
}

$(document).ready(function () {
  if (isMobileViewport()) {
    $(window).scroll(function () {
      if ($(this).scrollTop() > 800) {
        $(".product__sticky-atc").addClass("active");
      } else {
        $(".product__sticky-atc").removeClass("active");
      }
    });
  }
});

if (!isMobileViewport()) {
  $(".slider-for").slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    fade: true,
    asNavFor: ".slider-nav",
    prevArrow: `
    <span data-block="block-product-primary-module hide medium--block" class="arrow-left slick-arrow" style="z-index:1">
      <svg width="19px" height="30px" viewBox="0 0 19 30" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
        <g id="-" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
          <g id="+4-Buttons+" transform="translate(-917.000000, -1183.000000)" fill="#FA1C8A" fill-rule="nonzero">
            <polygon id="Path" transform="translate(926.500000, 1198.000000) rotate(90) translate(-926.500000, -1198.000000)" points="914.704663 1189 926.42487 1201.2087 938.145078 1189 941 1191.81739 926.42487 1207 912 1191.81739"></polygon>
          </g>
        </g>
      </svg>
    </span>
  `,
    nextArrow: `
    <span data-block="block-product-primary-module hide medium--block" class="arrow-right slick-arrow" style="">
      <svg width="19px" height="30px" viewBox="0 0 19 30" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
        <g id="-" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
          <g id="+4-Buttons+" transform="translate(-917.000000, -1183.000000)" fill="#FA1C8A" fill-rule="nonzero">
            <polygon id="Path" transform="translate(926.500000, 1198.000000) rotate(-90) translate(-926.500000, -1198.000000)" points="914.704663 1189 926.42487 1201.2087 938.145078 1189 941 1191.81739 926.42487 1207 912 1191.81739"></polygon>
          </g>
        </g>
      </svg>
    </span>
  `,
  });
}
$(".slider-nav").slick({
  slidesToShow: 8,
  slidesToScroll: 1,
  asNavFor: ".slider-for",
  dots: false,
  centerMode: true,
  focusOnSelect: true,
  centerPadding: "0", // Set the center padding to 0
  variableWidth: true, // Allow variable width
  useTransform: false,
});

$(".read-more").click(function () {
  $(".description-trimmed").toggleClass("visually-hidden");
  $(".description-fullw").toggleClass("visually-hidden");
  // $(this).text('Read Less');
});

// Select all elements with the class "magnetic-button"
var magneticButtons = document.querySelectorAll(".magnetic-button");

// Loop through each magnetic button and add event listeners
magneticButtons.forEach(function (magneticButton) {
  var buttonFiller = magneticButton.querySelector(".button__filler");
  var buttonTextInner = magneticButton.querySelector(
    ".button__text .button__text-inner"
  );

  magneticButton.addEventListener("mouseover", function () {
    magneticButton.classList.add("button-hover");
    buttonFiller.style.transform = "translate(0px, 0%)";
    // buttonTextInner.style.transform = "translate3d(0px, 75%, 0px)";
    // buttonTextInner.style.transform = "translate(0px, 0%)";
  });

  magneticButton.addEventListener("mouseout", function () {
    magneticButton.classList.remove("button-hover");
    buttonFiller.style.transform = "translate(0px, -75%)";
    // buttonTextInner.style.transform = "translate(0px, 0%)";
    // buttonTextInner.style.transform = "translate(0px, 75%)";
  });
});

$(".add-success-badge-top").on("click", function () {
  // Get the 'data-id' attribute value from the clicked element
  console.log("here");
  var dataIdValue = $(this).attr("data-id");

  // Find the element with class 'checkData' and matching 'data-id'
  var checkDataElement = $('.checkData[data-id="' + dataIdValue + '"]');

  // If a matching element is found, remove the 'hide' class
  if (checkDataElement.length > 0) {
    checkDataElement.removeClass("hide");
  }
});

$(document).ready(function () {
  const container = $(".featured-products-overflowscroll-container");
  const cellWidth = $(".cell.product").outerWidth();
  const scrollAmount = 3; // Adjust this value to control the scroll distance

  $(".arrow.right").on("click", function () {
    console.log("wdaw");
    container.animate({ scrollLeft: "+=" + scrollAmount * cellWidth });
  });

  $(".arrow.left").on("click", function () {
    container.animate({ scrollLeft: "-=" + scrollAmount * cellWidth });
  });
});
